import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs as CoreBreadcrumbs } from '@vds-core/breadcrumbs';
var propTypes = {
  /*
   * A prop that will invert the colors of the breadcrumbs for use on dark backgrounds.
   *
   */
  surface: PropTypes.oneOf(["light", "dark"])
};
var defaultProps = {
  surface: "light"
};

var Breadcrumbs = function Breadcrumbs(props) {
  return /*#__PURE__*/React.createElement(CoreBreadcrumbs, props);
};

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;
export default Breadcrumbs;